import { Outlet } from 'react-router-dom-v5-compat'
import { Flex, PageTemplate } from '@npco/zeller-design-system'

import { BreadcrumbsBase } from 'components/Breadcrumbs/BreadcrumbsBase'
import { MobileNavHeader } from 'components/Sidebar/components/MobileNavHeader/MobileNavHeader'

import { useItemsBreadcrumbs } from '../../hooks/useItemsBreadcrumbs'

export const SettingsLayout = () => {
  const breadcrumbParts = useItemsBreadcrumbs()

  return (
    <PageTemplate
      HeaderPrimaryRow={
        <PageTemplate.HeaderPrimaryRow>
          <Flex alignItems="center" height="48px">
            <BreadcrumbsBase breadcrumbParts={breadcrumbParts} />
          </Flex>
        </PageTemplate.HeaderPrimaryRow>
      }
      HeaderMobileRow={<MobileNavHeader />}
    >
      <PageTemplate.Section>
        <Outlet />
      </PageTemplate.Section>
    </PageTemplate>
  )
}
